import React, { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const GRADIENT = 'linear-gradient(135deg, #090A0B 0%, #001a4d 40%, #004AAD 75%, #0082FB 100%)';

const sidebarSections = [
  { group: 'Report', items: [
    { id: 'founders-note',  label: "Founder's Note",   icon: 'FileText' },
    { id: 'mypitch-canvas', label: 'myPitch Canvas',   icon: 'Layout'   },
  ]},
  { group: 'Review & Scoring', items: [
    { id: 'summary',         label: 'myDecX Score Overview',    icon: 'PieChart'      },
    { id: 'slides',          label: 'Slide-by-Slide Analysis',  icon: 'Presentation'  },
    { id: 'all-issues',      label: 'All Issues Identified',    icon: 'AlertTriangle' },
    { id: 'recommendations', label: 'Expert Recommendations',   icon: 'Lightbulb'     },
    { id: 'versions',        label: 'Version History',          icon: 'GitBranch'     },
  ]},
  { group: 'Intelligence & Insights', items: [
    { id: 'benchmark',       label: 'Competitor Benchmark',       icon: 'Target'     },
    { id: 'industry-trends', label: 'Industry Trends & Analysis', icon: 'TrendingUp' },
    { id: 'persona-outputs', label: 'Persona & Match Score',      icon: 'Users'      },
    { id: 'market-analysis', label: 'Market Specific Analysis',   icon: 'BarChart2'  },
  ]},
  { group: 'Artefact Builder', items: [
    { id: 'outreach-sequence', label: 'Outreach Sequence',          icon: 'Send'       },
    { id: 'battle-cards',      label: 'Battle Cards',              icon: 'Shield'     },
    { id: 'key-documents',     label: 'Key Documents',             icon: 'FolderOpen' },
    { id: 'custom-prompt',     label: 'Custom Prompt',             icon: 'Terminal'   },
    { id: 'revised-deck',      label: 'Ready to Use Revised Deck', icon: 'Layers', disabled: true },
  ]},
];

const ResultsSidebar = ({ activeSection, setActiveSection, iltcNum, startupData, slidesData }) => {
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, [activeSection]);

  return (
    <nav style={{
      background: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: 280,
      minWidth: 0,
      maxWidth: '100%',
      height: '100%',
      boxSizing: 'border-box',
    }}>
      <style>{[
        '@keyframes upsellSlide{0%,42%{transform:translateX(0)}50%,92%{transform:translateX(-100%)}100%{transform:translateX(0)}}',
        '.sb-nav-scroll::-webkit-scrollbar{width:4px}',
        '.sb-nav-scroll::-webkit-scrollbar-track{background:transparent}',
        '.sb-nav-scroll::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.14);border-radius:3px}',
        '.sb-nav-scroll::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.26)}',
        '.sb-nav-scroll::-webkit-scrollbar-button{display:none}',
        '.sb-nav-item{transition:background 0.12s,color 0.12s;}',
        '.sb-nav-item:hover:not(.active):not(:disabled){background:rgba(0,0,0,0.03)!important;color:#1d1d1f!important;}',
        '.sb-nav-item:hover:not(.active):not(:disabled) .sb-nav-icon{color:#1d1d1f!important;}',
      ].join('')}</style>

      {/* Header */}
      <div style={{
        padding: '14px 20px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        borderBottom: '1px solid rgba(0,0,0,0.04)',
        boxSizing: 'border-box',
      }}>
        <span style={{ fontFamily: "'Sansation', sans-serif", fontSize: 13, fontWeight: 700, color: '#1d1d1f' }}>
          Report Sections
        </span>
        <span style={{ fontFamily: 'inherit', fontSize: 11, fontWeight: 500, color: '#aeaeb2', background: '#f8f8fa', padding: '2px 8px', borderRadius: 6 }}>
          {sidebarSections.reduce(function(a, g) { return a + g.items.length; }, 0)}
        </span>
      </div>

      {/* Scrollable nav */}
      <div
        className="sb-nav-scroll"
        style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(0,0,0,0.14) transparent',
          paddingBottom: 8,
          minHeight: 0,
        }}
      >
        {sidebarSections.map(function(group, gIdx) {
          return (
            <div key={group.group}>
              <div style={{
                fontFamily: "'Sansation', sans-serif",
                fontSize: 9.5,
                fontWeight: 700,
                letterSpacing: '0.09em',
                textTransform: 'uppercase',
                color: '#c7c7cc',
                padding: (gIdx !== 0 ? '14px' : '10px') + ' 20px 5px',
              }}>
                {group.group}
              </div>

              {group.items.map(function(item) {
                var isActive = activeSection === item.id;
                return (
                  <button
                    key={item.id}
                    ref={isActive ? activeRef : null}
                    className={'sb-nav-item' + (isActive ? ' active' : '')}
                    disabled={item.disabled}
                    onClick={function() { if (!item.disabled) setActiveSection(item.id); }}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 9,
                      padding: '7px 20px 7px 17px',
                      fontSize: 12.5,
                      fontWeight: isActive ? 600 : 450,
                      color: isActive ? '#004AAD' : '#6e6e73',
                      background: isActive ? 'rgba(0,74,173,0.065)' : 'transparent',
                      borderLeft: '3px solid ' + (isActive ? '#004AAD' : 'transparent'),
                      borderTop: 'none',
                      borderRight: 'none',
                      borderBottom: 'none',
                      cursor: item.disabled ? 'not-allowed' : 'pointer',
                      opacity: item.disabled ? 0.38 : 1,
                      textAlign: 'left',
                      fontFamily: 'inherit',
                      boxSizing: 'border-box',
                      outline: 'none',
                      lineHeight: 1.4,
                      minWidth: 0,
                    }}
                  >
                    <span
                      className="sb-nav-icon"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        color: isActive ? '#004AAD' : '#94a3b8',
                        transition: 'color 0.12s',
                      }}
                    >
                      <Icon name={item.icon} size={15} color="currentColor" />
                    </span>
                    <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {item.label}
                    </span>

                    {item.disabled && (
                      <span style={{
                        fontFamily: 'inherit',
                        fontSize: 8.5,
                        fontWeight: 700,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        color: '#aeaeb2',
                        background: '#f4f4f6',
                        padding: '2px 6px',
                        borderRadius: 5,
                        flexShrink: 0,
                        border: '0.5px solid rgba(0,0,0,0.06)',
                      }}>
                        Soon
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div style={{
        borderTop: '1px solid rgba(0,0,0,0.05)',
        flexShrink: 0,
        background: '#ffffff',
        paddingBottom: 12,
        boxSizing: 'border-box',
        width: '100%',
      }}>
        <div style={{
          fontFamily: "'Sansation', sans-serif",
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: '0.09em',
          textTransform: 'uppercase',
          color: '#c7c7cc',
          padding: '11px 20px 7px',
        }}>
          Current Deck
        </div>

        {[
          { label: 'Score',    value: iltcNum ? (iltcNum + '/100') : null },
          { label: 'Company',  value: (startupData && startupData.startup_name) || null },
          { label: 'Industry', value: (startupData && startupData.industry) || null },
          { label: 'Slides',   value: (slidesData && slidesData.length) || (startupData && startupData.slide_usage) || null },
        ].filter(function(r) { return r.value; }).map(function(r, i) {
          return (
            <div key={i} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '3px 20px',
              gap: 8,
              boxSizing: 'border-box',
            }}>
              <span style={{ fontFamily: 'inherit', fontSize: 11.5, color: '#86868b', flexShrink: 0 }}>
                {r.label}
              </span>
              <span style={{
                fontFamily: "'Sansation', sans-serif",
                fontSize: 11.5,
                fontWeight: 600,
                color: '#1d1d1f',
                maxWidth: 130,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'right',
              }}>
                {r.value}
              </span>
            </div>
          );
        })}

        {/* Upsell carousel */}
        <div style={{
          margin: '10px 12px 0',
          borderRadius: 12,
          overflow: 'hidden',
          background: GRADIENT,
          position: 'relative',
          height: 86,
          boxSizing: 'border-box',
        }}>
          <div style={{
            display: 'flex',
            animation: 'upsellSlide 8s ease-in-out infinite',
            height: '100%',
          }}>
            {[
              { label: 'Post-Audit Service', title: 'Book a 1:1 Deck Strategy Call', cta: 'Book on Topmate' },
              { label: 'Slidr DFY Services', title: 'We Build Your Pitch Deck',       cta: 'Learn More'     },
            ].map(function(slide, i) {
              return (
                <div key={i} style={{
                  minWidth: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                }}>
                  <p style={{ fontFamily: 'inherit', fontSize: 8, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.60)', margin: '0 0 4px 0' }}>
                    {slide.label}
                  </p>
                  <p style={{ fontFamily: "'Sansation', sans-serif", fontSize: 12, fontWeight: 700, color: '#fff', lineHeight: 1.3, margin: '0 0 6px 0' }}>
                    {slide.title}
                  </p>
                  <p style={{ fontFamily: 'inherit', fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.82)', margin: 0 }}>
                    {slide.cta}
                  </p>
                </div>
              );
            })}
          </div>

          <div style={{ position: 'absolute', bottom: 7, right: 12, display: 'flex', gap: 4 }}>
            {[0, 1].map(function(i) {
              return (
                <span key={i} style={{
                  width: i === 0 ? 12 : 4,
                  height: 4,
                  borderRadius: 2,
                  background: 'rgba(255,255,255,0.5)',
                }} />
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
};

export { sidebarSections };
export default ResultsSidebar;